'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _performanceNow = require('./vendor/performanceNow');

var _performanceNow2 = _interopRequireDefault(_performanceNow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var lastArg = null;
var lastResult = null;

exports.default = function (history) {
  if (history === lastArg) {
    return lastResult;
  }
  var initialPathname = history.location.pathname;


  lastArg = history;
  lastResult = {
    pathname: initialPathname,
    listen: function listen(cb) {
      return history.listen(function (_ref) {
        var pathname = _ref.pathname;

        var timestamp = (0, _performanceNow2.default)();
        cb({
          timestamp: timestamp,
          pathname: pathname
        });
      });
    }
  };

  return lastResult;
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/react-rhumb/static-1.2431/js/historyAdapterV4.js
// module id = 638
// module chunks = 3 4